module.exports = __webpack_public_path__ + "static/media/success.08a61b4b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/map/success.svg
// module id = 1503
// module chunks = 0